import { render, staticRenderFns } from "./targetDetails.vue?vue&type=template&id=2d127c8c&scoped=true&"
import script from "./targetDetails.vue?vue&type=script&lang=js&"
export * from "./targetDetails.vue?vue&type=script&lang=js&"
import style0 from "./targetDetails.vue?vue&type=style&index=0&id=2d127c8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d127c8c",
  null
  
)

export default component.exports